import React, { Component } from "react";
import { connect } from "react-redux";
import { toggleView } from "../actions";
import "../styles/NavigationMenu.css";

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    prevPage: () => dispatch(toggleView(ownProps.prev)),
    nextPage: () => dispatch(toggleView(ownProps.next))
  };
};

class NavigationMenuContainer extends Component {
  render() {
    const prevButton = this.props.prev
      ? <button className="navigator__button" onClick={this.props.prevPage}>
          {"< " + this.props.prev}
        </button>
      : null;
    const nextButton = this.props.next
      ? <button className="navigator__button" onClick={this.props.nextPage}>
          {this.props.next + " >"}
        </button>
      : null;

    return (
      <div className="navigation-menu">
        <div className="prev-button">{prevButton}</div>
        <div className="next-button">{nextButton}</div>
      </div>
    );
  }
}

const NavigationMenu = connect(null, mapDispatchToProps)(
  NavigationMenuContainer
);

export default NavigationMenu;



// WEBPACK FOOTER //
// ./src/components/NavigationMenu.js